import { api } from "config";
import { PATHS } from "constants/index";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "state/loading/hooks";
import { PaymentInfo, UserActionsData, UserData, KitOrder, CheckPayment } from "types";
import { useStripe } from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import { useUser } from "state/user/hooks";

//import { useProductsData } from "state/orderKits/hooks";
import axios from "axios"
export const usePaymentAndUpload = () => {
  const { isLoading, setIsLoading } = useLoading();
  const stripe = useStripe();
  const navigate = useNavigate();
  const { updateUser, user } = useUser();

  const _uploadUserData = useCallback(
    async (userData: UserData) => {
      try{
      setIsLoading(true);
      var formdata = new FormData();
      for (const [key, value] of Object.entries(userData)) {
        formdata.append(key, value);
      }
      const { data } = await api.post("upload-data/", formdata);
      setIsLoading(false);
      return data.data;
    }
    catch(e:any){
      toast.error(e.message);
    }
    finally{
      setIsLoading(false);
    }
  },
    [setIsLoading]
  );
  const _uploadLabData = useCallback(
    async (files: any) => {
      try{
      setIsLoading(true);
      var formdata = new FormData();
      [...files].map(file => {
        formdata.append('files',file);
      });
       await api.post("lab_file/upload/", formdata);
       toast.success("Files Upload Successfully");
    }
    catch(e:any){
      toast.error(e.message);
    }
    finally {
      setIsLoading(false);
    }
    },
    [setIsLoading]
  );

  
  const getUserData = useCallback(async () => {
    const { data } = await api.get("user/details/");
    updateUser({ credits: data.data.credits, kit_credits:data.data.kit_credits, is_SuperAdmin:data.data.is_superuser });
  }, []);

  const processFilesOnly = useCallback(
    async (userData: UserData) => {
      try {
        setIsLoading(true);
        const data = await _uploadUserData(userData);
        if (!user) return;
        if (userData.service_type === "special")
          updateUser({ credits: user.credits - 2 });
        if (userData.service_type === "normal")
          updateUser({ credits: user.credits - 1 });

        toast.success("File Upload Successfully");
        navigate(`${PATHS.CATEGORIES}/${data.report_id}`);
      } catch (e: any) {
        toast.error(e.message);
      } finally {
        setIsLoading(false);
      }
    },
    [setIsLoading, _uploadUserData, navigate, user, updateUser]
  );

  const getProducts = useCallback(
    async () => {
      try {
        setIsLoading(true);
        const { data } = await api.get("products/");
        if (data.success) {
          return data.data;
        } else toast.error(data.error.message);
      } catch (e: any) {
        toast.error(e.message);
      } finally {
        setIsLoading(false);
      }
    },
    [setIsLoading]
  );

  const getOrderById = useCallback(
    async (orderId: string) => {
      try {
        setIsLoading(true);
        const { data } = await api.get(`order/${orderId}/`);
        if (data.success) {
          return data.data;
        } else toast.error(data.error.message);
      } catch (e: any) {
        toast.error(e.message);
      } finally {
        setIsLoading(false);
      }
    },
    [setIsLoading]
  );

  return {
    getProducts,
    getOrderById,
    getUserData,
    processFilesOnly,
    isLoading,
    credits: user?.credits ?? 0,
    kit_credits: user?.kit_credits ?? 0,
    _uploadLabData,
  };
};
